import Card from "@mui/material/Card";
import { useEffect, useRef } from "react";
import { Box, Button } from "@maysoft/common-component-react";
import { CardDetailMessage } from "@maysoft/circle-common-react";

import Strings from "constants/strings";

import { Mode } from "constants/enum";
import { DashboardLayout } from "layout";


const PushNotificationScreen = () => {

    const closeRef = useRef<any>(null);
    const submitRef = useRef<any>(null);

    useEffect(() => { }, []);

    return (
        <DashboardLayout
            isPermission
            allowSettingLayout
            requiredOrganization
            title={Strings.NOTIFICATION.PUSH_NOTIFICATION}
            route={[{ title: Strings.NOTIFICATION.PUSH_NOTIFICATION, route: "" }]}
        >
            <Box>
                <Box sx={{
                    mb: 2,
                    gap: 1,
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "end",
                }}
                >
                    <Button onClick={() => {
                        submitRef.current?.click();
                    }}>
                        {Strings.NOTIFICATION.SEND}
                    </Button>
                </Box>
                <Card>
                    <CardDetailMessage
                        closeRef={closeRef}
                        submitRef={submitRef}

                        hiddenMultiLanguage
                        getGroupNonHierarchical

                        onSubmit={() => { }}
                        onCancel={(value) => { }}
                    />
                </Card>
            </Box>
        </DashboardLayout>
    );
};

export default PushNotificationScreen;
